if (!customElements.get('image-link-carousel')) {
  customElements.define(
    'image-link-carousel',
    class ImageLinkCarousel extends HTMLElement {
      connectedCallback() {
        this.viewport = this.querySelector('.image-link-carousel__track');
        this.pagination = this.querySelector('.swiper-pagination');
        this.mobileMediaQuery = window.matchMedia('screen and (max-width: 749px)');
        this.onBreakpointChange = this.syncCarousel.bind(this);

        this.mobileMediaQuery.addEventListener('change', this.onBreakpointChange);
        this.syncCarousel();
      }

      disconnectedCallback() {
        this.mobileMediaQuery?.removeEventListener('change', this.onBreakpointChange);
        this.destroyCarousel();
      }

      syncCarousel() {
        if (!this.mobileMediaQuery.matches) {
          this.destroyCarousel();
          return;
        }

        if (this.carousel || !this.viewport || !this.pagination || !window.FoxTheme?.Carousel) return;

        this.carousel = new window.FoxTheme.Carousel(this.viewport, {
          slidesPerView: 1,
          spaceBetween: 20,
          speed: 500,
          loop: true,
          threshold: 2,
          pagination: {
            el: this.pagination,
            clickable: true,
          },
          autoplay: {
            delay: 5000,
            disableOnInteraction: false,
            pauseOnMouseEnter: true,
          },
        }, [FoxTheme.Swiper.Autoplay]);
        this.carousel.init();
      }

      destroyCarousel() {
        if (!this.carousel?.slider) return;

        this.carousel.slider.destroy(true, true);
        this.carousel = null;
      }
    }
  );
}
